export default __webpack_public_path__ + "static/media/icon2.009135ec.svg";